<template>
  <div>
    <section-landing/>
        <v-layout justify-center>
            <v-btn color="primary" class="ma-5" style="text-transform: none; font-size: 1.25rem; line-height: 1.5em; height: 1.5em;"
             :to="{name: 'hosts'}">
              Informace pro hosty
            </v-btn>
        </v-layout>
<!--    <base-section header="O nás">-->
<!--      <p class="text-xs-center">Již brzy...</p>-->
<!--      <v-timeline>-->
<!--        <v-timeline-item v-for="item in items" :key="item.title">-->
<!--          <template #opposite>-->
<!--            <span :class="`headline font-weight-bold`">{{item.date}}</span>-->
<!--          </template>-->
<!--          <v-card>-->
<!--            <v-img :src="item.image"/>-->
<!--            <v-card-title class="primary">-->
<!--              <h2 class="display-1 white&#45;&#45;text font-weight-light">{{item.title}}</h2>-->
<!--            </v-card-title>-->
<!--          </v-card>-->
<!--        </v-timeline-item>-->
<!--      </v-timeline>-->
<!--    </base-section>-->


  </div>
</template>

<script>

  import SectionLanding from "@/components/SectionLanding";

  export default {
    name: "HomePage",
    components: { SectionLanding},
    data() {
      return {
        items: [
          {
            title: "Anett*",
            date: "1991",
          },
          {
            title: "David*",
            date: "1992",
          },
          {
            title: "Brácha Lukáš",
            date: "1997",
            description: "Narození bráchy Lukáše"
          },
          {
            title: "Ségra Adéla",
            date: "2000",
            description: "Narození ségry Adély",
            image: "https://images.pexels.com/photos/248797/pexels-photo-248797.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500"
          },
          {
            title: "BiGy BoBa",
            date: "2003",
            description: "Oba jsme nastoupili na Biskupské gymnázium Bohuslava Balbína v Hradci Králové",
            image: "/images/timeline/bigy.jpg"
          }
        ]
      }
    },
    mounted() {
      this.$ga.page("/")
    }
  }
</script>
